<template>
  <section id="admin-filter">
    <h4>Tariff filter - {{ action }}</h4>
    <div class="micro-tabs clearfix">
      <span :class="[ filter === 1 ? 'active' : '' ]" @click="filter = 1">Filters</span>
      <span :class="[ filter === 2 ? 'active' : '' ]" @click="filter = 2">Cont'd</span>
    </div>
    <div v-show="filter === 1">
      <div class="form-group">
        <label for="tar-code" class="form-label">Code</label>
        <input type="text" class="form-control" id="tar-code" v-model="entity.l.c"/>
      </div>
      <div class="form-group">
        <label for="tar-desc" class="form-label">Name</label>
        <input type="text" class="form-control" id="tar-desc" v-model="entity.l.n"/>
      </div>
      <div class="form-group">
        <label for="tar-desc" class="form-label">Description</label>
        <input type="text" class="form-control" id="tar-desc" v-model="entity.l.d"/>
      </div>
      <div class="form-group">
        <label for="tar-contract-name" class="form-label">Contract Name</label>
        <input type="text" class="form-control" id="tar-contract-name" v-model="entity.l.cN"/>
      </div>
      <div class="form-group">
        <label for="tar-lookup-type" class="form-label">Lookup Type</label>
        <select v-model="entity.l.lT" class="form-control" id="tar-lookup-type">
          <option value=""></option>
          <option v-for="(opt, i) in getSystemOptions('LOOKUP_TYPE')" :value="opt.id">{{ opt.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label class="form-label">Owner</label>
        <autocomplete
          :dataset="partySearchResults"
          title="Owner"
          placeHolder="Type to search"
          :initVal="entity.l.o"
          v-on:changing="data => partySearchText = data"
          :fnFormatText="displayParty"
          :fnSelectValue="displayParty"
          v-on:selection-made="p => entity.l.o = p"
        ></autocomplete>
      </div>
      <div class="form-group">
        <label for="filter-tariff-mode" class="form-label">Mode</label>
        <select v-model="entity.l.m" class="form-control" id="filter-tariff-mode">
          <option value=""></option>
          <option v-for="(opt, i) in getSystemOptions('MODE')" :value="opt.id">{{ opt.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="tariff-shipment-type" class="form-label">Shipment Type</label>
        <select v-model="entity.l.sT" class="form-control" id="tariff-shipment-type">
          <option value=""></option>
          <option v-for="(opt, i) in getSystemOptions('SHIPMENT_CATEGORY')" :value="opt.id">{{ opt.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="tariff-transport-type" class="form-label">Transport Type</label>
        <select v-model="entity.l.tT" class="form-control" id="tariff-transport-type">
          <option value=""></option>
          <option v-for="(opt, i) in getSystemOptions('TRANSPORT_TYPE')" :value="opt.id">{{ opt.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="tariff-goods-type" class="form-label">Goods Type</label>
        <select v-model="entity.l.gT" class="form-control" id="tariff-goods-type">
          <option value=""></option>
          <option v-for="(opt, i) in getSystemOptions('GOODS_TYPE')" :value="opt.id">{{ opt.name }}</option>
        </select>
      </div>
    </div>
    <div v-show="filter === 2">
      <div class="form-group">
        <label for="tariff-container-type" class="form-label">Container Type</label>
        <select v-model="entity.lD.cT" class="form-control" id="tariff-container-type">
          <option value=""></option>
          <option v-for="(opt, i) in getSystemOptions('CONTAINER_TYPE')" :value="opt.id">{{ opt.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="tariff-woodloose-type" class="form-label">Wood / Loose</label>
        <select v-model="entity.lD.wL" class="form-control" id="tariff-woodloose-type">
          <option value=""></option>
          <option v-for="(opt, i) in getSystemOptions('WOOD_LOOSE')" :value="opt.id">{{ opt.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="tariff-min-bp" class="form-label">Minimum Breakpoint</label>
        <input type="number" v-model="entity.lD.miB" class="form-control" id="tariff-min-bp" step="1"/>
      </div>
      <div class="form-group">
        <label for="tariff-max-bp" class="form-label">Maximum Breakpoint</label>
        <input type="number" v-model="entity.lD.maB" class="form-control" id="tariff-max-bp" step="1"/>
      </div>
      <div class="form-group">
        <label class="form-label">Origin Location</label>
        <autocomplete
          :dataset="locationSearchResults"
          title="Origin Location"
          placeHolder="Type to search"
          :initVal="entity.lD.oL"
          v-on:changing="data => locationSearchText = data"
          :fnFormatText="locationFormat"
          :fnSelectValue="locationFormat"
          v-on:selection-made="updateFrom"
        >
        </autocomplete>
      </div>
      <div class="form-group">
        <label class="form-label">Destination Location</label>
        <autocomplete
          :dataset="locationSearchResults"
          title="Destination Location"
          placeHolder="Type to search"
          :initVal="entity.lD.dL"
          v-on:changing="data => locationSearchText = data"
          :fnFormatText="locationFormat"
          :fnSelectValue="locationFormat"
          v-on:selection-made="updateTo"
        >
        </autocomplete>
      </div>
      <div class="form-group">
        <label class="form-label">On Carriage Location</label>
        <autocomplete
          :dataset="locationSearchResults"
          title="On Carriage Location"
          placeHolder="Type to search"
          :initVal="entity.lD.oCL"
          v-on:changing="data => locationSearchText = data"
          :fnFormatText="locationFormat"
          :fnSelectValue="locationFormat"
          v-on:selection-made="updateOnCarriage"
        >
        </autocomplete>
      </div>
      <div class="form-group">
        <label class="form-label">Pre Carriage Location</label>
        <autocomplete
          :dataset="locationSearchResults"
          title="Pre Carriage Location"
          placeHolder="Type to search"
          :initVal="entity.lD.pCL"
          v-on:changing="data => locationSearchText = data"
          :fnFormatText="locationFormat"
          :fnSelectValue="locationFormat"
          v-on:selection-made="updatePreCarriage"
        >
        </autocomplete>
      </div>
    </div>
    <div class="form-group">
      <label for="is-suspended" class="form-label">Suspended?</label>
      <select class="form-control" id="is-suspended" v-model="entity.l.s" :disabled="actionType !== null">
        <option value=""></option>
        <option value="1">True</option>
        <option value="0">False</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq" @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq" @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import API from '../../../../api/endpoints'
  export default {
    name: 'TariffFilter',
    mixins: [ FilterMixin, HelperMixin ],
    data () {
      return {
        filter: 1,
        partySearchText: '',
        partySearchResults: [],
        locationSearchResults: [],
        locationSearchText: '',
        /*
        * using proper key names caused excessive url generation and was
        * on occasions too excessive for 'referer' header (and thus err)
        */
        entity: {
          l: {
            c: null,
            n: null,
            d: null,
            lT: null,
            s: null,
            o: null,
            cN: null,
            m: null,
            sT: null,
            tT: null,
            gT: null
          },
          lD: {
            oL: null,
            dL: null,
            cT: null,
            wL: null,
            miB: null,
            maB: null,
            oCL: null,
            pCL: null
          },
          action: null
        }
      }
    },
    components: {
      Autocomplete
    },
    watch: {
      actionType (newVal, oldVal) {
        this.updateSuspension(newVal)
        this.entity.action = newVal
      }
    },
    methods: {
      updateTo (to) {
        this.entity.lD.dL = to
        this.clearLocationData()
      },
      updateFrom (from) {
        this.entity.lD.oL = from
        this.clearLocationData()
      },
      updateOnCarriage (oCL) {
        this.entity.lD.oCL = oCL
        this.clearLocationData()
      },
      updatePreCarriage (pCL) {
        this.entity.lD.pCL = pCL
        this.clearLocationData()
      },
      clearLocationData () {
        this.locationSearch = ''
        this.locationSearchResults = []
      },
      locationFormat (location) {
        let str = ''
        if (location.name) {
          str += location.name
        }
        if (location.subdivision) {
          str += `, ${location.subdivision}`
        }
        if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
          str += `, ${location.country.code}`
        }
        return str
      },
      displayParty (p) {
        return `${p.name}, ${p.code}`
      },
      tariffSearch () {
        if (this.actionType) {
          // event.$emit('right-open', { callerId: this._uid, component: this.filterName, data: {}, event: this.filterEventName })
        } else {
          this.emitSearch()
        }
      },
      updateSuspension (val) {
        let x = null
        switch (val) {
          case 'suspend':
            x = 0
            break
          case 'unsuspend':
            x = 1
            break
        }
        this.entity.l.s = x
      }
    },
    computed: {
      actionType () {
        return this.initData.action || null
      },
      action () {
        switch (this.actionType) {
          case 'suspend':
            return 'Mass Suspension'
          case 'unsuspend':
            return 'Mass Unsuspension'
          case 'update':
            return 'Mass Update'
          default:
            return 'Search'
        }
      }
    },
    mounted () {
      this.updateSuspension(this.actionType)
      this.entity.action = this.actionType
    }
  }
</script>
<style>
  .micro-tabs {
    color: #fff;
    text-align: center;
    margin: 20px;
  }
  .micro-tabs span {
    border: 1px solid;
    padding: 3px 6px;
    cursor: pointer;
    transition: all 0.5s;
  }
  .micro-tabs span.active {
    color: #000;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// TariffFilter.vue?60428227